import React from "react";
import styled from "styled-components";
import { Row, Col, Dropdown, OverlayTrigger } from "react-bootstrap";
import { Route_URLs } from "routesURLs";
import { Authorise } from "helpers/Authorization";
import { useState } from "react";
import Table from "ui/table";
import useDebounce from "hooks/useDebounce";

import moment from "moment";
import NumberFormat from "react-number-format";
import { InfoIcon, ExportIcon, ReceivablesIcon, ImportIcon, CommentIcone } from "assets/icons.js";
import jwt_decode from "jwt-decode";
import { useEffect } from "react";
import ReactTooltip from "react-tooltip";
import downloadPdf from "assets/download.gif";
import { GetRefundDetails, UseTransactionList, ApplySyncERP } from "queries/actuals";
import PrivateLayout from "layouts/organization-ui/PrivateLayout";
import Page from "ui/Page";

// import { StyledDropDown, TableSection } from "./Styles";
import customersServices from "services/customers.services";
import { FilterSection, StyledDropDown, TableSection } from "../Styles";
import actualServices from "services/actual.services";
import TransactionFilter from "screens/customer/TransactionFilter";
import Tooltip from "ui/Tooltip";
import PaymentReceipt from "utils/pdftemplates/paymentReceipt";
import { useGeneralSettings } from "queries/generalSettings";
import { pdf } from "@react-pdf/renderer";
import RefundTransactionModal from "../modals/RefundTransactionModal";
import RefundModal from "../modals/RefundModal";
import RefundSuccessModal from "../modals/RefundSuccessModal";
import { Popover } from "ui/Popover";
import DotImage from "../../../assets/images/icon-dot.png";
import DownloadTransaction from "../DownloadTransaction";
import CustomerSearch from "filters/search/CustomerSearch";
import { StyledButton } from "filters/Style";

const SyncButton = styled(StyledButton)`
  text-align: center;
  padding: 12px;
  width: auto;
  min-width: 142px;
  margin-right: 10px;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const StyledTable = styled.div`
  table {
    tr {
      &:hover {
        input {
          border: 1px solid #ffffff !important;
        }
      }
    }
    input {
      background: transparent;
      border: 0;
      color: #b5b5b5;
      text-align: center;
      width: 79px;
    }
  }
`;

const StyledDiv = styled.div`
    // .icon-div {
   width: 51px;
    height: 40px;
    background: #3a3b48 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 26px #00000017;
    border: 1px solid #707070;
    border-radius: 20px;
    display: inline-block;
    margin-left: 10px;
    padding: 5px;
    cursor: pointer;
    svg {
      margin-left: 14px;
      path {
        fill: #33c2df;
      }
    }
  }
  // }
`

export default function ReceivableTransactions() {
  const { data: generalSettingsData } = useGeneralSettings();
  // const generalSettingsData = { showCashApplication: true };
  const pay = useGeneralSettings();
  const [initialPage, setinitialPage] = useState(0);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [isLoadingSyncERP, setIsLoadingSyncERP] = useState(false);
  console.log("pay--->", pay)
  const applySyncERPMutation = ApplySyncERP();

  let tokenData = sessionStorage.getItem("userToken");
  let decodedData = jwt_decode(tokenData);

  const rowClick = (e, row, editId) => {
    return null;
  };

  const [filterData, setFilterData] = useState({
    limit: "",
    searchString: "",
    deliveryDueDate: "",
    minAmount: "",
    maxAmount: "",
    bucket: "",
    pageNumber: 0,
    order: "desc",
    columnName: "TransactionTimeStamp",
    customerId: decodedData.username,
    invoiceNumber: "",
    Type: "",
    syncStatus: "ALL",
    TransactionStatus: "",
  });
  const user = {
    firstName: "",
    lastName: "",
  };
  const handlePageChange = (page) => {
    filterData.pageNumber = page;
    setFilterData({ ...filterData, ...filterData });
    setinitialPage(page);
  };

  const handleInfo = async (transactionId) => {
    const filterData = { transactionId }; // Construct filterData
    setRefundFilterData(filterData); // Update the state to trigger the query
    setShowRefundTransactionModal(true);
  }

  const updateFilters = (updatedFilterData) => {
    if (updatedFilterData.searchString == "") {
      handlePageChange(0);
    }
    if (filterData.searchString == "" && updatedFilterData.searchString != "") {
      handlePageChange(0);
    }
    let newFilterState = { ...filterData, ...updatedFilterData };
    setFilterData(newFilterState);
  };
  const onHeaderClick = (column) => {
    filterData.columnName = column.id;
    filterData.order = filterData.order === "desc" ? "asc" : "desc";
    let updatedFilter = { ...filterData, ...filterData };

    setFilterData(updatedFilter);
  };

  const debouncedfilterData = useDebounce(filterData, 1000);
  const {
    data: transactionData,
    isLoading: isloading,
    refetch: refetchData,
  } = UseTransactionList(debouncedfilterData);
  useEffect(() => {


    transactiondata.map((value) => {
      let invoiceAmount = 0
      if (value?.partialPay) {
        value.partialPaymentDetails.map((amount) => invoiceAmount += amount.originalAmount)
        value["totalOriginalAmount"] = invoiceAmount
      }
    })
  }, [transactionData, isloading]);

  let transactiondata = transactionData
    ? transactionData.data.transactions
    : [];

  useEffect(() => { }, [transactionData, isloading]);
  const totalcount = transactionData ? transactionData?.data?.totalRecords : "";

  const handleDownload = async (transactionId) => {
    const url = await actualServices.exportInvoice(transactionId);

    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const handlePaymentReceiptDownload = async (transactionId) => {
    const res = await actualServices.GetTenantPdfreceiptData(transactionId);
    // console.log('transaction data ', res);
    const doc = <PaymentReceipt paymentData={res} />;

    // Generate a blob from the PDF document
    const asPdf = pdf(); // Initialize the pdf() generator
    asPdf.updateContainer(doc); // Load the document into the pdf container

    // Convert the document to a blob
    const blobdata = await asPdf.toBlob();
    console.log('blog: ', blobdata);

    // Trigger the file download using file-saver
    // const blob = new Blob(byteArrays, { type: "application/pdf" });
    const url = URL.createObjectURL(blobdata);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Transaction_${transactionId}.pdf`; // Specify the filename for the downloaded file
    link.click();
    // Clean up the URL object
    URL.revokeObjectURL(url);
    // document.body.removeChild(link);
  };
  // const [time, setTime] = useState(Date.now());

  // useEffect(() => {
  //   const interval = setInterval(() => setTime(Date.now()), 1000);
  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, []);
  // function isWithin30Seconds(time) {
  //   const inputTime = moment(time);

  //   const now = moment();

  //   const durationInSeconds = now.diff(inputTime, "seconds");

  //   return Math.abs(durationInSeconds) <= 30;
  // }

  const columns = React.useMemo(
    () => {
      const baseColumns = [
        {
          Header: "Transaction Id",
          accessor: "transactionId",
          id: "transactionId",
          width: 150,
          minWidth: 130,
          Cell: (props) => (
            <>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{ marginRight: "5px" }}
                  onClick={(e) => {
                    handlePaymentReceiptDownload(
                      props.row.original.transactionId,
                    );
                  }}
                >
                  {props.row.original.TransactionStatus === "APPROVED" ||
                    props.row.original.TransactionStatus === "PENDING" ||
                    props.row.original.TransactionStatus === "SUCCESS" ||
                    props.row.original.TransactionStatus === "UPDATE" ? (
                    <ExportIcon
                      font-size="20px"
                      style={{ marginRight: "10px" }}
                    />
                  ) : (
                    ""
                  )}
                </span>
                {props.row.original.transactionId}
              </div>
            </>
          ),
        },
        {
          Header: "Invoice No. / Reference No.",
          accessor: (d) => {
            return d;
          },
          id: "invoiceArray",
          width: 100,
          minWidth: 80,
          Cell: ({ value }) => {
            if (value?.invoiceArray && value?.invoiceArray?.length > 0) {
              return (
                <div>
                  {value.invoiceArray.map((id, index) => (
                    <div key={index}>{id}</div>
                  ))}
                </div>
              );
            } else {
              return <div>{value?.referenceNumber}</div>;
            }
          },
          disableSortBy: true,
        },
        {
          Header: "Customer Name",
          accessor: "payeeName",
          id: "payeeName",
          width: 110,
          minWidth: 80,
          disableSortBy: true,
        },
        {
          Header: "Company Name",
          accessor: "companyName",
          id: "companyName",
          width: 140,
          minWidth: 100,
        },
        {
          Header: "Payment Method",
          accessor: "Type",
          id: "Type",
          width: 110,
          minWidth: 80,
        },
        {
          Header: "Card Type",
          accessor: "cardBrand",
          id: "cardBrand",
          width: 110,
          minWidth: 80,
          disableSortBy: true,
        },
        {
          Header: "Last 4 digits",
          accessor: "lastFourDigit",
          id: "lastFourDigit",
          width: 110,
          minWidth: 80,
          disableSortBy: true,
        },
        {
          Header: "Date",
          accessor: "TransactionTimeStamp",
          id: "TransactionTimeStamp",
          width: 100,
          minWidth: 80,
          accessor: (d) => {
            return moment(d.TransactionTimeStamp).format("MM/DD/YYYY");
          },
        },
        {
          Header: "Amount",
          id: "totalOriginalAmount",
          width: 150,
          minWidth: 100,
          disableSortBy: true,
          Cell: (props) => {
            let amount = props?.row?.original?.invoiceAmount ? props?.row?.original?.partialPay ? props?.row?.original?.totalOriginalAmount : props.row.original.invoiceAmount : props.row.original.TotalAmount
            return (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                <NumberFormat
                  thousandSeparator={true}
                  prefix={"$"}
                  value={parseFloat(amount).toFixed(2)}
                  displayType="text"
                  isNumericString={true}
                  decimalScale={2}
                />
                {props?.row?.original?.comment && (
                  <>
                    <CommentIcone

                      data-tip={props?.row?.original?.comment}
                      data-for={`comment-tooltip-${props.row.index}`}
                    />
                    <Tooltip id={`comment-tooltip-${props.row.index}`} place="top" />
                  </>
                )}
              </div>
            );
          }
        },
        {
          Header: "Amount Paid",
          id: "TotalAmount",
          width: 150,
          minWidth: 100,
          Cell: (props) => {
            let amount = props?.row?.original?.invoiceAmount ? props.row.original.invoiceAmount : props.row.original.TotalAmount
            return (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                <NumberFormat
                  thousandSeparator={true}
                  prefix={"$"}
                  value={parseFloat(amount).toFixed(2)}
                  displayType="text"
                  isNumericString={true}
                  decimalScale={2}
                />
              </div>
            );
          }
        },
        {
          Header: "Processing Fees",
          accessor: "surcharge",
          id: "surcharge",
          width: 100,
          minWidth: 80,
          disableSortBy: true,
          Cell: (props) => {
            return (
              <NumberFormat
                thousandSeparator={true}
                prefix={"$"}
                value={props.row.original.surcharge ? parseFloat(props.row.original.surcharge).toFixed(2) : 0}
                displayType="text"
                isNumericString={true}
                decimalScale={2}
              />
            )
          }
        },
        {
          Header: "Simpli Discount",
          accessor: "loyaltyDiscount",
          id: "loyaltyDiscount",
          width: 100,
          minWidth: 80,
          disableSortBy: true,
          show: pay?.data?.loyaltyAccess ? true : false,
          Cell: (props) => {
            return (
              <NumberFormat
                thousandSeparator={true}
                prefix={"$"}
                value={props.row.original.loyaltyDiscount ? parseFloat(props.row.original.loyaltyDiscount).toFixed(2) : 0}
                displayType="text"
                isNumericString={true}
                decimalScale={2}
              />
            )
          }
        },
        {
          Header: "Charged",
          accessor: "invoiceAmount",
          id: "invoiceAmount",
          disableSortBy: true,
          width: 100,
          minWidth: 80,
          Cell: (props) => {
            return (
              <NumberFormat
                thousandSeparator={true}
                prefix={"$"}
                value={parseFloat(props.row.original.TotalAmount).toFixed(2)}
                displayType="text"
                isNumericString={true}
                decimalScale={2}
              />
            )
          }
        },
        {
          Header: "Refund Amount",
          accessor: "refundAmount",
          id: "refundAmount",
          width: 100,
          disableSortBy: true,
          minWidth: 80,
          Cell: (props) => {
            return (
              <div style={{ display: "flex", gap: "2px" }}>
                {props.row.original.TransactionStatus === "APPROVED" ||
                  props.row.original.TransactionStatus === "SUCCESS"
                  ? <div>
                    <InfoIcon style={{ marginRight: "10px" }} onClick={() => { handleInfo(props.row.original.transactionId) }} />
                  </div> : <div style={{ marginRight: '20px' }}></div>}
                <div>
                  <NumberFormat
                    thousandSeparator={true}
                    prefix={"$"}
                    value={parseFloat(props.row.original.refundAmount).toFixed(2)}
                    displayType="text"
                    isNumericString={true}
                    decimalScale={2}
                  />
                </div>
              </div>
            )
          }
        },
        {
          Header: "Status",
          accessor: "TransactionStatus",
          id: "TransactionStatus",
          width: 100,
          minWidth: 80,
        },
        {
          Header: "Action",
          Cell: ({ row }) => {
            let access = false
            if (row.original.Type === 'Credit Card' && pay?.data?.refundOption?.includes('credit_card')) {
              access = true
            } else if (row.original.Type === 'Debit Card' && pay?.data?.refundOption?.includes('debit_card')) {
              access = true
            } else if (row.original.Type === 'Classic ACH' && pay?.data?.refundOption?.includes('classic_ach')) {
              access = true
            } else if (row.original.Type === 'ACH' && pay?.data?.refundOption?.includes('ach')) {
              access = true
            } else {
              access = false
            }
            return (
              <>
                {row.original.TransactionStatus === "APPROVED" && access && <OverlayTrigger
                  trigger={
                    "click"
                  }
                  rootClose={true}
                  placement="bottom-end"
                  overlay={popover(row)}
                >
                  <img
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    alt="menu"
                    className="image"
                    src={DotImage}
                  />
                </OverlayTrigger>}
              </>
            )
          },
          id: "action",
          width: 100,
          minWidth: 80,
        }
      ];

      if (generalSettingsData?.showCashApplication && generalSettingsData?.isPaymentEnable && generalSettingsData?.isCashAppEnable) {
        baseColumns.unshift({
          Header: "",
          accessor: "select",
          Cell: ({ row }) => {
            const isSynced = row.original.syncStatus?.toLowerCase() === "closed" && row.original.syncerp === 1;
            const isApproved = row.original.TransactionStatus === "APPROVED";
            const isPending = row.original.syncStatus?.toLowerCase() === "pending";
            const isPaidForInvoice = (row.original.type?.trim().toLowerCase() === "invoice");

            if (!isPaidForInvoice) {
              return <div></div>;
            }

            return (
              <input
                type="checkbox"
                checked={selectedTransactions.includes(row.original.transactionId) || isSynced}
                disabled={!isApproved || isSynced || isPending || isLoadingSyncERP}
                style={!isApproved || isSynced || isPending || isLoadingSyncERP ? { opacity: 0.5, cursor: 'not-allowed', accentColor: '#ccc' } : {}}
                onChange={(e) => {
                  if (!isApproved || isSynced || isPending || isLoadingSyncERP) return;
                  if (e.target.checked) {
                    setSelectedTransactions([...selectedTransactions, row.original.transactionId]);
                  } else {
                    setSelectedTransactions(selectedTransactions.filter(id => id !== row.original.transactionId));
                  }
                }}
              />
            );
          },
          disableSortBy: true,
          width: 50,
        });

        baseColumns.splice(-1, 0, {
          Header: "Sync Status",
          accessor: "syncStatus",
          id: "syncStatus",
          width: 100,
          minWidth: 80,
          Cell: ({ value, row }) => {
            const isPaidForInvoice = (row.original.type?.trim().toLowerCase() === "invoice");
            return isPaidForInvoice ? (value || "Open") : "N / A";
          }
        });
      }

      return baseColumns;
    },
    [pay, selectedTransactions, generalSettingsData]
  );
  const [showRefundModal, setHideRefundModal] = useState(false)
  const [transactionDetails, setTransactionDetails] = useState({})
  const [showRefundTransactionModal, setShowRefundTransactionModal] = useState(false)
  const [refundFilterData, setRefundFilterData] = useState(null);
  const { data: refundDetails, refetch: refetchRefundDetails } = GetRefundDetails(refundFilterData);

  const popover = (row) => {
    return (
      <Popover id="popover-basic" style={{ width: "157px", padding: "5px 0px" }}>
        <Popover.Body>
          <>

            {/* {row.original.TransactionStatus === 'APPROVED' && parseFloat(row.original.invoiceAmount) !== row.original.refundAmount   && */}

            <div className="pop-list-links">

              <span
                className="link noBarClick"
                onClick={() => {
                  setHideRefundModal(true)
                  setTransactionDetails(row.original)
                }}
              >
                Refund
              </span>



            </div>
            {/* } */}
          </>
        </Popover.Body>
      </Popover>
    );
  };
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [refundData, setRefundData] = useState()

  const handleSuccessModal = (data, modal) => {


    if (modal) {
      setRefundData(data)
      setShowSuccessModal(true)
    }
  }

  // const getRefundDetails = GetRefundDetails({})

  const handleApplySyncERP = async () => {
    const tenantName = sessionStorage.getItem("tenantName");
    if (!tenantName) {
      alert("Tenant name not found");
      return;
    }
    setIsLoadingSyncERP(true);
    try {
      await applySyncERPMutation.mutateAsync({
        tenantName,
        transactionIds: selectedTransactions
      });
      // Clear selected transactions and refetch after 2 seconds
      setTimeout(() => {
        setSelectedTransactions([]);
        refetchData();
        setIsLoadingSyncERP(false);
      }, 5000);
    } catch (error) {
      console.error(error);
      alert("Error applying sync ERP");
      setIsLoadingSyncERP(false);
    }
  };
  return (
    <>
      <RefundTransactionModal show={showRefundTransactionModal} hide={() => setShowRefundTransactionModal(false)} data={refundDetails} />
      <RefundModal
        show={showRefundModal}
        hide={() => {
          setHideRefundModal(false);
          setTransactionDetails({}); // Reset transaction details
        }}
        data={transactionDetails}
        refetch={refetchData}
        handleSuccessModal={handleSuccessModal}
      />
      {showSuccessModal && <RefundSuccessModal data={refundData} show={showSuccessModal} hide={() => setShowSuccessModal(false)} />}
      <PrivateLayout>
        <Page>
          <Page.Header>
            <Row className="m-0">
              <Col sm={3} className="p-0">
                <StyledDropDown
                  variant="secondary"
                  align="end"
                  title="Transactions"
                >
                  <Authorise
                    showUnAuthorisedComponenet={<></>}
                    allowedRoles={[
                      "admin",
                      "simplicollect",
                      "SimpliCollect&Simplipay",
                      "simpliCollect&Reward",
                      "read-only",
                    ]}
                  >
                    <Dropdown.Item href={Route_URLs.actuals_receivables}>
                      Receivables
                    </Dropdown.Item>
                  </Authorise>
                  <Authorise
                    showUnAuthorisedComponenet={<></>}
                    allowedRoles={[
                      "admin",
                      "simplipay",
                      "SimpliCollect&Simplipay",
                      "read-only",
                    ]}
                  >
                    <Dropdown.Item href={Route_URLs.actuals_payables}>
                      Payables
                    </Dropdown.Item>
                  </Authorise>
                  <Authorise
                    showUnAuthorisedComponenet={<></>}
                    allowedRoles={[
                      "admin",
                      "simplicollect",
                      "SimpliCollect&Simplipay",
                      "simpliCollect&Reward",
                      "read-only",
                    ]}
                  >
                    <Dropdown.Item href={Route_URLs.actuals_collections}>
                      Collections
                    </Dropdown.Item>
                  </Authorise>

                  <Authorise
                    showUnAuthorisedComponenet={<></>}
                    allowedRoles={[
                      "admin",
                      "simplipay",
                      "SimpliCollect&Simplipay",
                      "read-only",
                    ]}
                  >
                    <Dropdown.Item href={Route_URLs.actuals_payments}>
                      Payments
                    </Dropdown.Item>
                  </Authorise>
                </StyledDropDown>
              </Col>
              <Col></Col>
            </Row>
          </Page.Header>
          <Page.Body>
            <Row style={{ display: "flex" }}>
              <FilterSection
                style={{
                  position: "relative",
                  bottom: "30px",
                  margin: "4px -27px -40px",
                  justifyContent: "end",
                }}
              >
                <div style={{ display: "flex", gap: "10px", justifyContent: "space-between", alignItems: "center", padding: '20px 0px 0px 27px' }}>
                  <CustomerSearch handleFilterData={updateFilters} />
                  {/* <DownloadTransaction /> */}

                  <div>
                    {generalSettingsData?.showCashApplication && generalSettingsData?.isPaymentEnable && generalSettingsData?.isCashAppEnable && (
                      <SyncButton
                        disabled={selectedTransactions.length === 0 || isLoadingSyncERP}
                        onClick={handleApplySyncERP}
                      >
                        {isLoadingSyncERP ? "Syncing ERP..." : "Sync ERP"}
                      </SyncButton>
                    )}
                    <TransactionFilter handleFilterData={updateFilters} />

                    <StyledDiv >
                      <a
                        onClick={async () => {
                          let link = await actualServices.exportTransactionList(
                            filterData
                          );

                          window.open(link, "_blank");
                        }}
                      >
                        <ImportIcon data-tip="Export" data-for="export" />
                        <Tooltip id="export" place="top" />
                      </a>
                    </StyledDiv>
                  </div>
                  {/* <button onClick={async()=> await actualServices.exportTransactionList(filterData)}>
                 Export
                </button> */}
                  {/* <button */}
                  {/* </button> */}
                </div>
                {/* <div className="icon-div">
                <a
                  onClick={async () => {
                    let link = await customersServices.getallcustomersDetails(
                      filterData
                    );
                    window.open(link, "_blank");
                  }}
                >
                  <ReceivablesIcon data-tip="Export" data-for="export" />
                  <Tooltip id="export" place="top" />
                </a>
              </div> */}
              </FilterSection>
            </Row>
            <TableSection>
              <Col className="p-0">
                <StyledTable>
                  {transactiondata?.length >= 0 && (
                    <Table
                      data={transactiondata}
                      columns={columns}
                      onHeaderClick={onHeaderClick}
                      totalCount={totalcount}
                      handlePageChange={handlePageChange}
                      initialPage={initialPage}
                      rowClick={rowClick}
                      isloading={isloading}
                    />
                  )}
                </StyledTable>
              </Col>
            </TableSection>
          </Page.Body>
        </Page>
      </PrivateLayout>
    </>
  );
}